import { Box, List, ListItem, Typography } from '@cmg/design-system';
import React from 'react';

const LIST_ITEMS: string[] = [
  'IPO: IPO Low–IPO High',
  'FO & Blocks: Re Offer Low–Re Offer High',
  'Converts: Coupon Talk Low–High / Premium Talk Low–High',
];

export const PriceRangeHeaderTooltipContent: React.FC = () => {
  return (
    <Box>
      <Typography variant="tooltip">
        Price Range will display based off the offering type
      </Typography>
      <List dense disablePadding>
        {LIST_ITEMS.map((value, index) => (
          <ListItem key={value} aria-label={value} disablePadding>
            {value}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
